import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicSortUp({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M8 2h.02a1 1 0 01.07 0H8a1 1 0 01.63.22l.08.07 4 4a1 1 0 01-1.32 1.5l-.1-.08L9 5.4V13a1 1 0 01-2 .12V5.4L4.7 7.7a1 1 0 01-1.31.08l-.1-.08a1 1 0 01-.08-1.32l.08-.1 4-4 .08-.07h.01l-.09.07A1 1 0 018 2z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicSortUp.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicSortUp.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicSortUp svgRef={ref} {...props} />);
export default ForwardRef;
